import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs/";
import { AlertService, StateService, AppService } from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { EncryptionService } from "../_services/encryption.service";

class State {
  id: number;
  state_name: string;
  country_id: number;
  is_active: string;
}

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-state",
  templateUrl: "./state.component.html",
})
export class StateComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable
  dtElement: DataTableDirective;

  stateList: State[] = [];
  stateListTotal: any
  isSubmitted = false;
  getState = {
    id: "",
    state_name: "",
    country_id: "",
    is_active: "N",
  };
  modalReference: NgbActiveModal;
  modalTitle: string;
  cntry = {};
  start: number = 0;
  pageLength: number = 10;

  constructor(
    public router: Router,
    private dataService: StateService,
    private alertService: AlertService,
    private AppService: AppService,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private modalService: NgbModal,
  ) {}
  state = {
    id: "",
    state_name: "",
    country_id: "",
    is_active: "Y",
  };
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);

    this.getStatesList();
    this.dataService
      .getAllCountry()
      .pipe()
      .subscribe((data) => {
        this.cntry = data["country"];
      });
  }

  // allState() {
  //   this.loadShow();
  //   this.dataService
  //     .getAllState()
  //     .pipe()
  //     .subscribe((data) => {
  //       this.stateList = data["state"];
  //       this.rerender();
  //       this.loadHide();
  //     });
  // }
  
  getRowNumber(index: number): number {
    return this.start + index + 1;
  }
  

  getStatesList() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: this.pageLength,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/all-state-datatable",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters)),
              ),
            },
            {},
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);

            this.stateList = resp.data
            this.stateListTotal = resp["recordsTotal"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "state_name" },
        { data: "country_name" },
        { data: "created_at" },
        { data: "is_active" },
        
      ],
    };
  }

  open(content) {
    this.isSubmitted = false;
    if (this.getState.id != null) {
      this.getState.id = "";
    }
    ((this.state.state_name = ""),
      (this.state.country_id = ""),
      (this.state.is_active = "Y"));
    this.modalTitle = "Add State";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  edit(id, content) {
    this.loadShow();
    this.dataService
      .getState(id)
      .pipe()
      .subscribe((data) => {
        this.getState = data["state"];
        this.state = {
          id: this.getState.id,
          state_name: this.getState.state_name,
          country_id: this.getState.country_id,
          is_active: this.getState.is_active,
        };
        this.loadHide();
        this.modalTitle = "Edit State";
        this.modalReference = this.modalService.open(content, {
          backdrop: "static",
          keyboard: false,
        });
      });
  }

  save(val, f) {
    this.isSubmitted = true;

    if (this.isFieldsInvalid(this.state.state_name)) {
      return;
    }

    if (f.form.valid) {
      this.loadShow();
      if (val.id == "") {
        this.dataService
          .save(this.state)
          .pipe()
          .subscribe(
            (data) => {
              this.loadHide();
              this.modalReference.close();
              this.alertService.success("State saved successfully", true);
             const table = $("#state_tab").DataTable();
            table.ajax.reload(null, false);
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            },
          );
      } else {
        this.dataService
          .stateUpdate(this.state)
          .pipe()
          .subscribe(
            (data) => {
              this.loadHide();
              this.modalReference.close();
              this.alertService.success("State updated successfully", true);
                          const table = $("#state_tab").DataTable();
            table.ajax.reload(null, false);
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            },
          );
      }
    }
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .stateDelete(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success("State deleted successfully", true);
            item.is_active = item.is_active === "Y" ? "N" : "Y";
                        const table = $("#state_tab").DataTable();
            table.ajax.reload(null, false);
          } else {
            this.alertService.error("State error");
          }
        },
        (error) => {
          this.alertService.error(error);
        },
      );
    this.loadHide();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
